module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//13.jpg?294106653d0c592516df5178b0eda223";